import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { CommonUI } from 'app/common/ui';
// #if brand.code == 'zont' || brand.code == 'valtec'
import { ZontContent } from 'app/zont-content';
// #endif
// #if brand.code == 'baxi'
// import { BaxiContent } from 'console/baxi/app/ui';
// #endif
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
export const UniversalUI = (props) => {
    const { ui } = props;
    const large = isMediumUI();
    let ContentType = null;
    // #if brand.code == 'zont' || brand.code == 'valtec'
    ContentType = ZontContent;
    // #endif
    // #if brand.code == 'baxi'
//     ContentType = BaxiContent;
    // #endif
    return (_jsx(CommonUI, { large: large, children: _jsxs(_Fragment, { children: [_jsx(ContentType, { ui: ui, large: large }), _jsx(Outlet, {})] }) }));
};
